import { useState } from "react";
import { ApiCall } from "../helper/axios";

export const useDownloadPDF = () => {
  const [loading, setLoading] = useState(false);
  const download = async (url, data, fileName) => {
    try {
      setLoading(true);
      const res = await ApiCall("POST", url, {
        ...data,
        responseType: "blob",
      });
      if (res?.status === 200) {
        const blob = new Blob([res?.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    download,
  };
};
